@charset "UTF-8";

@use "@user/assets/css/variables";

.contents {
  grid-template-rows: auto auto 1fr auto;
}

//검색 영역
.work-srch-area {
  position: relative;
  display: grid;
  grid-template-columns: auto 1px auto 1px auto 1px auto 1fr;
  align-items: center;
  gap: 0 12px;
  margin: 0 0 8px;
  padding: 8px 55px 8px 8px;
  border-radius: 4px;
  background: variables.$colorBgSrchArea;

  //구분선
  >em {
    display: block;
    background: variables.$colorBorderBase;
  }

  >div {
    display: grid;

    //항목명
    >p {
      padding: 2px 0 0;
      font-size: variables.$sizeFontItemName;;
    }
  }
  
  >div:nth-child(1) {
    grid-template-columns: auto auto;
    gap: 0 8px;

    >div {
      display: grid;
      grid-template-rows: auto auto auto;
      gap: 4px 0;
    }
  }

  >div:nth-child(3) {
    grid-template-rows: auto auto;
    gap: 4px 0;

  >div {
      display: grid;
      grid-template-columns: auto auto;
      grid-template-rows: 20px 20px;
      gap: 4px 8px;
    }
  }

  >div:nth-child(5) {
    grid-template-rows: auto auto;
    gap: 4px 0;
    

    >div {
      display: grid;
      grid-template-rows: 20px 20px;
      gap: 4px 8px;
    }
  }

  //검색어 입력
  .srch_item {
    grid-template-columns: auto auto auto auto;
    gap: 4px 8px;

    @media (max-width: 1750px) {
      grid-template-columns: auto auto auto;
    }

    >div {
      display: grid;
      grid-template-columns: 75px 150px;
      align-items: center;
      gap: 6px;

      >p {
        text-align: right;
        font-size: 13px;
      }
    }
  }

  //바코드
  >span {
    display: flex;
    align-items: center;
    justify-content: flex-end;

    >em {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 6px;

      >img {
        max-width: 140px;
        max-height: 34px;
      }

      >div {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        color: variables.$colorMain;
        font-size: variables.$sizeFontBarcode;
        font-weight: 700;

        i {
          display: block;
          width: 20px;
          height: 20px;
          background: url(@user/assets/images/common/barcode.svg) no-repeat;
          background-position: 50%;
          background-size: contain;
        }
      }
    }
  }

  //초기화 버튼
  >p {
    position: absolute;
    top: 50%;
    right: 20px;
    width: 24px;
    height: 24px;
    margin: -12px 0 0;
    z-index: 10;

    button {
      width: 24px;
      min-width: 24px;
      height: 24px;
      padding: 0;
      @include variables.textHidden;
    }
  }
}

//작업옵션
.work_option {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0 12px;
  padding: 8px;
  border-radius: 4px;
  background: variables.$colorBgSrchArea;

  >div {
    display: grid;
    grid-template-columns: auto auto;
    align-items: center;
    gap: 8px;

    &:nth-child(5),
    &:nth-child(7) {
      grid-template-columns: auto 100px
    }

    //항목명
    >p {
      font-size: variables.$sizeFontItemName;
    }

    >.MuiFormGroup-root {
      display: flex;
      align-items: center;
      gap: 12px;
    }
  }
}